import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

interface SectionDividerProps {
    title?: string
    children?: ReactNode
    className?: string
    colSpan?: number
}

export function SectionDivider({title, children, className, colSpan}: SectionDividerProps) {
    return (
        <div className={cn('border-t pt-3 mt-1', colSpan && `sm:col-span-${colSpan}`, className)}>
            {title && <p className="text-sm font-medium text-muted-foreground mb-2">{title}</p>}
            {children}
        </div>
    )
}
